<div class="software-settings-container" *ngIf="softwareSpecification">
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.display.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row">
                <div class="table-cell" style="--col-width: 4">
                    {{ 'system-specifications.display.language' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ language | translate }}
                </div>
            </div>
            <div class="simple-table">
                <div class="thin-row">
                    <div class="table-cell left-text" style="--col-width: 5">
                        {{ 'system-specifications.display.graphs' | translate }}
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'graph.type.exhaust' | translate }}
                    </div>
                    <div class="table-cell end-align" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="
                                booleanIndicator;
                                context: {
                                    value: displayData.graphs.EXHAUST_GAS,
                                }
                            " />
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'graph.type.bar' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="booleanIndicator; context: { value: displayData.graphs.BAR_GRAPH }" />
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'graph.type.gauge' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="
                                booleanIndicator;
                                context: {
                                    value: displayData.graphs.ANALOG_METER,
                                }
                            " />
                    </div>
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    <div>
                        {{ 'system-specifications.display.mimic' | translate }}
                    </div>
                    <div class="info-container">
                        <mat-icon svgIcon="help" class="info-icon" />
                        <div class="info-message-container">
                            {{ 'system-specifications.display.info' | translate }}
                        </div>
                    </div>
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: displayData.mimics }" />
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    <div>
                        {{ 'system-specifications.display.curve' | translate }}
                    </div>
                    <div class="info-container">
                        <mat-icon svgIcon="help" class="info-icon" />
                        <div class="info-message-container">
                            {{ 'system-specifications.display.info' | translate }}
                        </div>
                    </div>
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: displayData.curve }" />
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    <div>
                        {{ 'system-specifications.display.control' | translate }}
                    </div>
                    <div class="info-container">
                        <mat-icon svgIcon="help" class="info-icon" />
                        <div class="info-message-container">
                            {{ 'system-specifications.display.info' | translate }}
                        </div>
                    </div>
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: displayData.control }" />
                </div>
            </div>
        </div>
    </div>

    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.clock.title' | translate }}
        </div>
        <div class="table-container">
            <div class="simple-table">
                <div class="thin-row">
                    <div class="table-cell left-text" style="--col-width: 5">
                        <div>
                            {{ 'system-specifications.clock.master' | translate }}
                        </div>
                        <div class="info-container">
                            <mat-icon svgIcon="help" class="info-icon" />
                            <div class="info-message-container">
                                <span class="semibold-text">
                                    {{ 'system-specifications.clock.master.info-1' | translate }}
                                </span>
                                {{ 'system-specifications.clock.master.info-2' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'system-specifications.clock.hardware' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="booleanIndicator; context: { value: clockData.master.hardware }" />
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'system-specifications.clock.input' | translate }}
                    </div>
                    <div class="table-cell" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="
                                booleanIndicator;
                                context: {
                                    value: clockData.master.input,
                                }
                            " />
                    </div>
                </div>
                <div class="simple-row">
                    <div class="table-cell regular-text" style="--col-width: 4">
                        {{ 'system-specifications.clock.server' | translate }}
                    </div>
                    <div class="table-cell end-align" style="--col-width: 1">
                        <ng-container
                            *ngTemplateOutlet="
                                booleanIndicator;
                                context: {
                                    value: clockData.master.server,
                                }
                            " />
                    </div>
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.clock.utc' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: clockData.utc }" />
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    {{ 'system-specifications.clock.backup' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: clockData.internalBackup }" />
                </div>
            </div>
            <div class="table-row">
                <div class="table-cell" style="--col-width: 3">
                    <div>
                        {{ 'system-specifications.clock.battery' | translate }}
                    </div>
                    <div class="info-container">
                        <mat-icon svgIcon="help" class="info-icon" />
                        <div class="info-message-container">
                            <span class="semibold-text">
                                {{ 'system-specifications.clock.battery.info-1' | translate }}
                            </span>
                            {{ 'system-specifications.clock.battery.info-2' | translate }}
                        </div>
                    </div>
                </div>
                <div class="table-cell" style="--col-width: 1">
                    <ng-container *ngTemplateOutlet="booleanIndicator; context: { value: clockData.batteryBackup }" />
                </div>
            </div>
        </div>
    </div>

    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.duty-settings.title' | translate }}
        </div>
        <div class="table-container">
            <div class="table-row">
                <div class="table-cell" style="--col-width: 4">
                    {{ 'system-specifications.duty-settings.title' | translate }}
                </div>
                <div class="table-cell" style="--col-width: 1">
                    {{ dutySettingsControl | translate }}
                </div>
            </div>
        </div>
    </div>
</div>

<app-anchor-menu
    [sectionList]="sectionsList"
    [currentSectionIndex]="currentSectionIndex"
    (onSelectSection)="handleScrollSection($event)"></app-anchor-menu>

<ng-template #booleanIndicator let-value="value">
    <div class="indicator-container" [class.trueIndicator]="value" [style.fill]="value ? '#D9D9D9' : '#546e7a'">
        <mat-icon class="indicator-icon" [svgIcon]="value ? 'check' : 'close'" />
        <div class="indicator-text" [style.color]="value ? '#185d2d' : '#546e7a'">
            {{ value ? ('dlg.yes' | translate) : ('dlg.no' | translate) }}
        </div>
    </div>
</ng-template>
